export enum AdminsRoles {
    None = 'None',
    SuperAdmin = 'SuperAdmin',
    Admin = 'Admin',
    Moderator = 'Moderator'
}

export const AdminRolesLabels: Record<AdminsRoles, string> = {
    [AdminsRoles.None]: '-',
    [AdminsRoles.SuperAdmin]: 'Супер Админ',
    [AdminsRoles.Admin]: 'Админ',
    [AdminsRoles.Moderator]: 'Модератор',
}

export const AdminRolesStyle: Record<AdminsRoles, string> = {
    [AdminsRoles.None]: '-',
    [AdminsRoles.SuperAdmin]: 'bg-warning',
    [AdminsRoles.Admin]: 'bg-primary',
    [AdminsRoles.Moderator]: 'bg-secondary',
}